import { removeDuplicates, removeEmpty } from '../utility/recentlyUsed';

const INITIAL_STATE = {
  values: {
    Client: [],
    Trader: [],
    ReceivingTrader: [],
    SalesPerson: [],
    Product: []
  }
};

const types = {
  RECEIVED_ITEMS: 'orb/recentlyUsed/RECEIVED_ITEMS',
  STORE_ITEM: 'orb/recentlyUsed/STORE_ITEM',
  GETTING_RECENTLY_USED_FROM_BROWSER: 'orb/recentlyUsed/GETTING_RECENTLY_USED_FROM_BROWSER'
};


export default function reducer(state = INITIAL_STATE, action = {}) {
  const storeValues = (obj, propName, value) => {
    // Store the new item to front of a new array
    const newObj = Object.assign({}, obj);
    const currentValues = newObj[propName];
    let newValues = [].concat(value, currentValues);
    newValues = cleanValues(newValues);
    newObj[propName] = newValues;
    return newObj;
  };

  switch (action.type) {
    case types.STORE_ITEM:
      return Object.assign({}, state, {
        values: storeValues(state.values, action.key, action.item)
      });
    case types.RECEIVED_ITEMS:
      return Object.assign({}, state, {
        values: storeValues(state.values, action.key, action.items)
      });
    default:
      return state;
  }
}
reducer.types = types;
reducer.initialState = INITIAL_STATE;


function receivedItems(key, items) {
  return {
    type: types.RECEIVED_ITEMS,
    key,
    items
  };
}

export function storeItem(key, item) {
  return {
    type: types.STORE_ITEM,
    key,
    item
  };
}

function gettingFromBrowser(localStorageKey) {
  return {
    type: types.GETTING_RECENTLY_USED_FROM_BROWSER,
    localStorageKey
  };
}

export function getRecentlyUsedFromBrowser() {
  return (dispatch, getState) => {
    const values = getState().recentlyUsed.values;
    const keys = Object.keys(values);
    keys.forEach((key) => {
      const localStorageKey = `recentlyUsed.${key}`;
      dispatch(gettingFromBrowser(localStorageKey));
      const items = JSON.parse(window.localStorage.getItem(localStorageKey));
      if (items) {
        dispatch(receivedItems(key, items));
      }
    });
  };
}

function cleanValues(values) {
  let newValues = removeDuplicates(values);
  newValues = removeEmpty(newValues);

  return newValues;
}

export function storeToRecentlyUsed(key, item) {
  return (dispatch, getState) => {
    if (item.keyOnly) {
      return;
    }
    const oldValues = getState().recentlyUsed.values[key];
    let newValues = [].concat(item, oldValues);
    newValues = cleanValues(newValues);

    dispatch(storeItem(key, item));
    const localStorageKey = `recentlyUsed.${key}`;
    const localStorageValues = JSON.stringify(newValues);
    window.localStorage.setItem(localStorageKey, localStorageValues);
  };
}

export function storeRecentlyUsedRecord(record) {
  return (dispatch, getState) => {
    const recordKeys = Object.keys(record);
    const recentlyUsedValues = getState().recentlyUsed.values;
    recordKeys.forEach((recordKey) => {
      const recordFieldValue = record[recordKey];
      if (recentlyUsedValues[recordKey] && recordFieldValue) {
        dispatch(storeToRecentlyUsed(recordKey, recordFieldValue));
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/recentlyUsed/reducer.js